export default "__VITE_ASSET__d9268eef__"